module.exports = __webpack_public_path__ + "img/logo.8bc0e940.png";